export default "__VITE_ASSET__CqFX_pkY__"